var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDueDateDaysWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.5V3.5M4 1.5V3.5M2 5.5H10M2 3.5C2 3.23478 2.10536 2.98043 2.29289 2.79289C2.48043 2.60536 2.73478 2.5 3 2.5H9C9.26522 2.5 9.51957 2.60536 9.70711 2.79289C9.89464 2.98043 10 3.23478 10 3.5V9.5C10 9.76522 9.89464 10.0196 9.70711 10.2071C9.51957 10.3946 9.26522 10.5 9 10.5H3C2.73478 10.5 2.48043 10.3946 2.29289 10.2071C2.10536 10.0196 2 9.76522 2 9.5V3.5Z",
    stroke: "#fff",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8C5.5 8.13261 5.55268 8.25979 5.64645 8.35355C5.74021 8.44732 5.86739 8.5 6 8.5C6.13261 8.5 6.25978 8.44732 6.35355 8.35355C6.44732 8.25979 6.5 8.13261 6.5 8C6.5 7.86739 6.44732 7.74021 6.35355 7.64645C6.25978 7.55268 6.13261 7.5 6 7.5C5.86739 7.5 5.74021 7.55268 5.64645 7.64645C5.55268 7.74021 5.5 7.86739 5.5 8Z",
    stroke: "#fff",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDueDateDaysWhite);
export default __webpack_public_path__ + "static/media/due_date_days_white.633aba96f60ed2fa83b14c47025c25b4.svg";
export { ForwardRef as ReactComponent };